import React from 'react';
import { bool } from 'prop-types';
import Logo from 'common/Logo';
import values from 'lodash/values';
import { TextStyle } from '@lavu-pos/lavu-react-components';
import {
	StyledLink,
	Colors,
	withIntlProvider,
	CircularProgress,
	intlShape,
} from 'modules/utils';

import { SUPPORTED_BROWSERS } from 'common/constants';

import {
	PageWrapper,
	LogoWrapper,
	Wrapper,
	Illustration,
	TextWrapper,
	BrowserItem,
	ImageIcon,
} from './styles';

import { isMobile } from '../utils/browserSupport';
import { locales as pageLocales } from './locales';

const { DESKTOP, MOBILE } = SUPPORTED_BROWSERS;
const BROWSERS_WHITELIST = isMobile() ? MOBILE : DESKTOP;

const propTypes = {
	intl: intlShape.isRequired,
	loading: bool.isRequired,
};
const UnsupportedBrowser = ({ intl: { messages }, loading }) => (
	<PageWrapper>
		<LogoWrapper>
			<Logo type="dark" />
		</LogoWrapper>
		<Wrapper>
			{loading ? (
				<CircularProgress />
			) : (
				<>
					<Illustration />
					<TextWrapper>
						<TextStyle
							variation="strong"
							fontSize={20}
							fontWeight="600"
							color={Colors.PRIMARY_TEXT}
						>
							{messages.browserNotSupported}
							<br />
							{messages.installOtherBrowser}
						</TextStyle>
						<br />
						{values(BROWSERS_WHITELIST).map(({ id, label, download, icon }) => (
							<BrowserItem key={id}>
								<ImageIcon source={icon} />
								<TextStyle>{label}</TextStyle>{' '}
								{download && (
									<StyledLink
										target="_blank"
										href={download}
										style={{ fontSize: 14, marginLeft: 18 }}
									>
										{messages.installNow}
									</StyledLink>
								)}
							</BrowserItem>
						))}
					</TextWrapper>
				</>
			)}
		</Wrapper>
	</PageWrapper>
);

UnsupportedBrowser.propTypes = propTypes;

export default withIntlProvider(pageLocales)(UnsupportedBrowser);
